export const SCOPE = 'comparison';
export const TOGGLE_FILTER_INDEX = `${SCOPE}/TOGGLE_FILTER_INDEX`;
export const REMOVE_FILTER_BY_INDEX = `${SCOPE}/REMOVE_FILTER_BY_INDEX`;
export const CLEAR_FILTER_INDICES = `${SCOPE}/CLEAR_FILTER_INDICES`;
export const ADD_METRIC = `${SCOPE}/ADD_METRIC`;
export const REMOVE_METRIC = `${SCOPE}/REMOVE_METRIC`;
export const ADD_SAVED_FILTER = `${SCOPE}/ADD_SAVED_FILTER`;
export const ADD_SAVED_FILTERS = `${SCOPE}/ADD_SAVED_FILTERS`;
export const EMPTY_SAVED_FILTER = `${SCOPE}/EMPTY_SAVED_FILTER`;

export const MODIFY_COMPARISON = `${SCOPE}/MODIFY_COMPARISON`;
export const CLEAR_MODIFY_COMPARISON = `${SCOPE}/CLEAR_MODIFY_COMPARISON`;
export const SET_ACTIVE_EDIT_ID = `${SCOPE}/SET_ACTIVE_EDIT_ID`;

export const FETCH_COMPARE_DATA = `${SCOPE}/FETCH_COMPARE_DATA`;
export const FETCH_COMPARE_DATA_SUCCESS = `${SCOPE}/FETCH_COMPARE_DATA_SUCCESS`;

export const TOGGLE_NEW_COMPARISON_DASHBOARD = `${SCOPE}/TOGGLE_NEW_COMPARISON_DASHBOARD`;
export const APPLY_SAVED_FILTERS = `${SCOPE}/APPLY_SAVED_FILTERS`;
export const APPLY_SAVED_METRICLIST = `${SCOPE}/APPLY_SAVED_METRICLIST`;
export const APPLY_SAVED_INDEX = `${SCOPE}/APPLY_SAVED_INDEX`;

export const UPDATE_ZOOM_INTERVAL = `${SCOPE}/UPDATE_ZOOM_INTERVAL`;
export const CLEAR_COMPARE_ZOOM_DATA = `${SCOPE}/CLEAR_COMPARE_ZOOM_DATA`;

export const FETCH_ZOOM_DATA_SUCCESS = `${SCOPE}/FETCH_ZOOM_DATA_SUCCESS`;

export const UPDATE_ZOOM_TOTAL = `${SCOPE}/UPDATE_ZOOM_TOTAL`;

export const SET_LOADER = `${SCOPE}/SET_LOADER`;

export const SET_FILTER_INDICES = `${SCOPE}/SET_FILTER_INDICES`;
export const UPDATE_COMPARE_DATA = `${SCOPE}/UPDATE_COMPARE_DATA`;
export const UPDATE_COMPARE_ZOOM_DATA = `${SCOPE}/UPDATE_COMPARE_ZOOM_DATA`;

export const SAVE_COMPARE_QUERIES = `${SCOPE}/SAVE_COMPARE_QUERIES`;

export const SAVE_EXPORTED_METRIC = `${SCOPE}/SAVE_EXPORTED_METRIC`;
export const EXPORT_COMPARE_METRIC = `${SCOPE}/EXPORT_COMPARE_METRIC`;
